module.exports = __webpack_public_path__ + "static/media/German_Marlene BG-23.5f0a28f5.png";